import { EditorialToolsService } from '../services/editorialToolsService';

export const loadImageFromUrl = (
  url: string,
  errorMessage = 'Bild konnte nicht geladen werden'
): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(errorMessage));
    img.src = url;
  });
};

export const loadBackgroundImage = (url: string): Promise<HTMLImageElement> => {
  return loadImageFromUrl(url, 'Hintergrund-Bild konnte nicht geladen werden');
};

export const loadCoverImage = async (
  coverNumber: string,
  errorMessage?: string
): Promise<HTMLImageElement> => {
  const { url: coverUrl } = await EditorialToolsService.call<{ url: string }>('/covers', { issue: coverNumber });
  return loadImageFromUrl(
    coverUrl,
    errorMessage || `Cover #${coverNumber} konnte nicht geladen werden`
  );
};
